/* eslint-disable jsx-a11y/anchor-is-valid */
// src/components/InsightSection.js
import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/ExploreSection.css";
import barchartIcon from "../assets/icon-barchart.png";
import arrowIcon from "../assets/arrow.png";

const InsightSection = () => {
  const navigate = useNavigate();

  return (
    <section className="explore-section">
      <div className="explore-inner">
        <h2 className="section-title">INSIGHT</h2>
        <div className="explore-card-group">
          {/* Card 1 */}
          <div
            className="explore-card"
            onClick={() => navigate("/voter-insight")}
          >
            <img src={barchartIcon} alt="Values" className="card-icon" />
            <h3 className="card-title">
              Voter Behavior Trend
            </h3>
            <p className="card-body">
            Find out why Online Information is crucial to Democracy
            </p>
            <a className="card-link">
              Learn More <img src={arrowIcon} alt="arrow" />
            </a>
          </div>

        
        </div>
      </div>
    </section>
  );
};

export default InsightSection;
